import { useParams } from 'wouter';
import { useSignoffData } from '@/hooks/useSignoffData';
import SignoffView from '@/components/signoff/SignoffView';

// NOTE: This page displays campaign snapshots contained in a locked cycle.
// Backend still uses /api/cycle-snapshots endpoints; frontend renames for clarity.

export default function CycleSnapshotViewerPage() {
  const params = useParams<{ cycleId: string; id: string }>();
  const cycleId = params?.cycleId;
  const snapshotId = params?.id;

  const { data, isLoading, error } = useSignoffData({ source: 'snapshot', snapshotId });

  if (!cycleId || !snapshotId) return <div className="p-4">Invalid URL</div>;
  if (isLoading) return <div className="p-4">Loading…</div>;
  if (error) return <div className="p-4 text-red-600">Failed to load cycle snapshot.</div>;

  const rows = (data as any)?.rows || (data as any)?.data || [];
  const meta = (data as any)?.meta || null;

  return (
    <div className="p-4 space-y-3">
      <div className="flex items-center gap-2 text-sm text-gray-700">
        <span className="px-2 py-1 rounded bg-gray-100">Cycle Snapshot {String(meta?.id || snapshotId).slice(-6)}</span>
        <span className="px-2 py-1 rounded bg-gray-100">Saved {meta?.createdAt ? new Date(meta.createdAt).toLocaleString() : ''}</span>
        <span className="px-2 py-1 rounded bg-gray-100">Cycle #{cycleId}</span>
      </div>
      <SignoffView data={rows} readOnly />
    </div>
  );
}



